<script setup>
import { computed, inject, ref } from 'vue';
import { styleVars } from './shared.js';
import { socialFeedHasContent } from '../socialPosts.js';
import SiteSocialFeed from '../SiteSocialFeed.vue';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

// Nothing to show is no block for a visitor, heading included: no posts,
// no channel, or a channel whose feed came back empty. The editor keeps
// its hints (Mus, 2026-10-11).
const editing = inject('tiqEditorCanvas', false);
const feedEmpty = ref(false);
const hasContent = computed(() => editing || (socialFeedHasContent(props.config) && !feedEmpty.value));
</script>

<template>
    <section v-if="hasContent" :id="config.anchor_id || null" class="th-block th-sec th-social" :style="styleVars(config)">
        <div class="th-wrap">
            <div v-if="config.eyebrow || config.heading || config.intro" class="th-social__head">
                <p v-if="config.eyebrow" class="th-eyebrow">{{ config.eyebrow }}</p>
                <h2 v-if="config.heading" class="th-h2">{{ config.heading }}</h2>
                <p v-if="config.intro" class="th-social__intro">{{ config.intro }}</p>
            </div>
            <SiteSocialFeed class="th-social__feed" :config="config" :org="org" @empty="feedEmpty = $event" />
        </div>
    </section>
</template>

<style scoped>
.th-social__head { margin-bottom: clamp(18px, 2.5vw, 28px); }
.th-social__intro { margin: 12px 0 0; font-size: 17px; color: var(--text-sub, var(--th-muted)); max-width: 60ch; text-wrap: pretty; }
.th-social__feed {
    --ssf-radius: var(--r);
    --ssf-line: var(--th-line);
    --ssf-muted: var(--th-meta);
    --ssf-accent: var(--accent);
}
.th-social__feed :deep(.tiq-ssf__title) { font-family: var(--th-display); font-weight: 800; }
</style>
